// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1BIWWA2li53h","button":"l4qOuIppmNxK","disabled":"_1D3CbvmaZ--Y","tabButton":"_3cOfI-jXol7W"};